import { EMPTY_SPY, type BluffItem, type ContentAccess, type SpyData, type TrufItem } from "@shared/content";
import type { GameId, Lang } from "@shared/types";
import { api } from "./api";
import { IS_DEMO } from "./asset";

interface Bank {
  bluff: BluffItem[];
  truf: TrufItem[];
  spy: SpyData;
}

const banks = new Map<Lang, Partial<Bank>>();

const demoLoaders: Record<Lang, () => Promise<{ default: Bank }>> = {
  ka: () => import("../demo/content-ka.json") as unknown as Promise<{ default: Bank }>,
  en: () => import("../demo/content-en.json") as unknown as Promise<{ default: Bank }>,
  ru: () => import("../demo/content-ru.json") as unknown as Promise<{ default: Bank }>,
};

/** Content for games hosted in this browser. Online rooms never need this (the server has it). */
export const localContent: ContentAccess = {
  bluff: (lang) => banks.get(lang)?.bluff ?? [],
  truf: (lang) => banks.get(lang)?.truf ?? [],
  spy: (lang) => banks.get(lang)?.spy ?? EMPTY_SPY(lang),
};

export async function ensureLocalContent(game: GameId, lang: Lang): Promise<void> {
  const bank = banks.get(lang) ?? {};
  banks.set(lang, bank);
  if (IS_DEMO) {
    if (!bank.spy) {
      const mod = (await demoLoaders[lang]()).default;
      bank.bluff = mod.bluff;
      bank.truf = mod.truf;
      bank.spy = mod.spy;
    }
    return;
  }
  // On the real site only Spy packs are public (Bluff/True-False answers stay on the server).
  if (game === "spy" && !bank.spy) {
    bank.spy = await api<SpyData>(`/content/spy/${lang}`);
  }
}
